import React, {useCallback} from "react";
import {List} from "antd";
import {useDispatch, useSelector} from "react-redux"
// import appActions from "@web/redux/app/actions";
import Day from "./Day";
import UserAvatar from "./UserAvatar";
import ListItemActive from "./ListItemActive";
import {ApplicationIcon} from "@web/assets/icons";
import PropTypes from "prop-types";

AppsListItem.propTypes = {
  app: PropTypes.object,
  date: PropTypes.number,
  onClick: PropTypes.func,
}

function AppsListItem(props) {
  const isMobile = true;
  const onClick = (e) => {
    const data = {
      path: props.path, app: props.app,
    };

    if (props.onClick) {
      return props.onClick(data, e);
    }
  };

  if (!props.app) {
    return null
  }

  return <List.Item
    key={props.path}
    className={`relative contacts-list-item ${isMobile ? 'is-mobile ' : ''}`}
    actions={[]}
    onClick={onClick}
  >
    <List.Item.Meta
      avatar={<UserAvatar icon={<ApplicationIcon className="muted-icon" />} />}
      title={
      <div className="space space-center-y">
        <h6 className={"capitalize"}>
          {props.app.appName || props.app.name}
        </h6>
        {/*{!!eventId && <ActivityIconStrip eventId={eventId} />}*/}
        <span key="ts" className="muted font-sm">
          <Day ts={props.app.date || props.date}/>
        </span>
      </div>
    }
      description={<label className="muted line-clamp-1" style={{width: "90%"}}>{props.app?.title || "NO TITLE"}</label>}
    />
    <ListItemActive
      path={props.path}
      offset={"5px"}
    />
  </List.Item>
}

export default AppsListItem;
